module.exports = __webpack_public_path__ + "img/interior-gallery-1.f57af996.jpg";